import { Component, inject, ChangeDetectionStrategy } from "@angular/core";
import {
	MAT_DIALOG_DATA,
	MatDialogTitle,
	MatDialogContent,
	MatDialogActions,
	MatDialogClose,
} from "@angular/material/dialog";
import { EInfoModalType, InfoModalConfig } from "../../../entities/core/info-modal-config";

import { MatButton } from "@angular/material/button";
import { NgxTolgeeModule } from "@tolgee/ngx";

@Component({
	selector: "app-info-modal",
	templateUrl: "./info-modal.component.html",
	styleUrls: ["./info-modal.component.scss"],
	changeDetection: ChangeDetectionStrategy.Eager,
	imports: [MatDialogTitle, MatDialogContent, MatDialogActions, MatButton, MatDialogClose, NgxTolgeeModule],
})
export class InfoModalComponent {
	data = inject<{
		message: string;
		config?: InfoModalConfig;
	}>(MAT_DIALOG_DATA);

	getColor(): string {
		if (this.data.config.type == EInfoModalType.WARNING) {
			return "warn";
		}
		return "primary";
	}
}
